"use client";

import { c as _c } from "react/compiler-runtime";
import { useFeaturesHospitalStore } from "@/features/hospital/model/store";
import { ReviewFilterModal } from "@/features/hospital/ui/organisms";
import { useRouter, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { FilterDetailButton, FilterResetButton, FilterSortingButton, FilterTreatmentButton } from "@/features/hospital/ui/molecules";
import { useQueryHospitalReviewAnalysis, useQueryHospitalSubjectsAnalysis } from "@/entities/hospital/hooks/queries";
import { useHospitalOriginId } from "@/entities/hospital/model/hospital-origin-id";
const ReviewFilter = () => {
  const $ = _c(47);
  const router = useRouter();
  const id = useHospitalOriginId();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("subject") ?? "";
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const subject = t0;
  let t1;
  if ($[2] !== searchParams) {
    t1 = searchParams.get("major") ?? "";
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const major = t1;
  let t2;
  if ($[4] !== searchParams) {
    t2 = searchParams.get("minor") ?? "";
    $[4] = searchParams;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const minor = t2;
  const {
    setSelectedSubjectFilter,
    setSelectedDetailFilter,
    resetReviewFilter
  } = useFeaturesHospitalStore();
  const {
    setSelectedReviewFilterTab,
    isOpenReviewFilterModal,
    setIsOpenReviewFilterModal
  } = useFeaturesHospitalStore();
  const {
    data: subjectsAnalysis
  } = useQueryHospitalSubjectsAnalysis(Number(id));
  const {
    data: reviewAnalysis
  } = useQueryHospitalReviewAnalysis(Number(id));
  const hasSubjectsAnalysisList = subjectsAnalysis && subjectsAnalysis.length > 0 ? subjectsAnalysis : undefined;
  const hasReviewAnalysisList = reviewAnalysis && reviewAnalysis.length > 0 ? reviewAnalysis : undefined;
  let t3;
  if ($[6] !== setIsOpenReviewFilterModal || $[7] !== setSelectedReviewFilterTab) {
    t3 = type => {
      setIsOpenReviewFilterModal(true);
      setSelectedReviewFilterTab(type);
    };
    $[6] = setIsOpenReviewFilterModal;
    $[7] = setSelectedReviewFilterTab;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleClickOpenReviewFilterModal = t3;
  let t4;
  if ($[9] !== id || $[10] !== resetReviewFilter || $[11] !== router) {
    t4 = () => {
      resetReviewFilter();
      router.push(`/review-detail/${id}`);
    };
    $[9] = id;
    $[10] = resetReviewFilter;
    $[11] = router;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const handleResetReviewFilter = t4;
  let t5;
  let t6;
  if ($[13] !== major || $[14] !== minor || $[15] !== setSelectedDetailFilter || $[16] !== setSelectedSubjectFilter || $[17] !== subject) {
    t5 = () => {
      if (subject) {
        setSelectedSubjectFilter(subject);
      }
      if (major || minor) {
        setSelectedDetailFilter({
          major,
          minor
        });
      }
    };
    t6 = [subject, major, minor, setSelectedDetailFilter, setSelectedSubjectFilter];
    $[13] = major;
    $[14] = minor;
    $[15] = setSelectedDetailFilter;
    $[16] = setSelectedSubjectFilter;
    $[17] = subject;
    $[18] = t5;
    $[19] = t6;
  } else {
    t5 = $[18];
    t6 = $[19];
  }
  useEffect(t5, t6);
  let t7;
  if ($[20] !== handleResetReviewFilter || $[21] !== major || $[22] !== minor || $[23] !== subject) {
    t7 = <FilterResetButton handleResetReviewFilter={handleResetReviewFilter} subject={subject} major={major} minor={minor} />;
    $[20] = handleResetReviewFilter;
    $[21] = major;
    $[22] = minor;
    $[23] = subject;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  const t8 = !!hasSubjectsAnalysisList;
  let t9;
  if ($[25] !== handleClickOpenReviewFilterModal || $[26] !== subject || $[27] !== t8) {
    t9 = <FilterTreatmentButton handleClickOpenReviewFilterModal={handleClickOpenReviewFilterModal} subject={subject} hasSubjectsAnalysisList={t8} />;
    $[25] = handleClickOpenReviewFilterModal;
    $[26] = subject;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  const t10 = !!hasReviewAnalysisList;
  let t11;
  if ($[29] !== handleClickOpenReviewFilterModal || $[30] !== major || $[31] !== minor || $[32] !== t10) {
    t11 = <FilterDetailButton handleClickOpenReviewFilterModal={handleClickOpenReviewFilterModal} major={major} minor={minor} hasReviewAnalysisList={t10} />;
    $[29] = handleClickOpenReviewFilterModal;
    $[30] = major;
    $[31] = minor;
    $[32] = t10;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t11 || $[35] !== t7 || $[36] !== t9) {
    t12 = <div className="flex min-w-0 flex-1 items-center gap-2">{t7}{t9}{t11}</div>;
    $[34] = t11;
    $[35] = t7;
    $[36] = t9;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <FilterSortingButton />;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== setIsOpenReviewFilterModal) {
    t14 = () => setIsOpenReviewFilterModal(false);
    $[39] = setIsOpenReviewFilterModal;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== isOpenReviewFilterModal || $[42] !== t14) {
    t15 = <ReviewFilterModal open={isOpenReviewFilterModal} onClose={t14} />;
    $[41] = isOpenReviewFilterModal;
    $[42] = t14;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== t12 || $[45] !== t15) {
    t16 = <div className="sticky top-[52px] left-0 right-0 flex min-w-0 items-center justify-between gap-3 border-b border-[#F4F4F5] px-4 pt-5 pb-2 text-right bg-white z-[10]">{t12}{t13}{t15}</div>;
    $[44] = t12;
    $[45] = t15;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  return t16;
};
export default ReviewFilter;